export default __webpack_public_path__ + "static/media/playlist-icon-black.2c56bede.svg";